import React, { useRef, useState, forwardRef } from 'react'
import { SelectPicker } from 'rsuite'
import ExploreButton from './exploreButton'
import { BsChevronDown, BsChevronUp } from 'react-icons/bs'
import cn from 'classnames'
import styles from './exploreDropDown.module.scss'

const Select = forwardRef(({ $lexus, className, ...props }, ref) => (
  <SelectPicker
    ref={ref}
    className={cn(
      styles.exploreDropdown,
      {
        [styles.exploreDropdownLexus]: $lexus
      },
      className
    )}
    {...props}
  />
))

Select.displayName = 'Select'

const ExploreDropDown = React.forwardRef((props, ref) => {
  const selectRef = useRef()
  const [isSelectOpen, setIsSelectOpen] = useState(false)
  const handleOpenDropdown = () => {
    if (selectRef.current) selectRef.current.open()
  }
  const showDropDown = (props.data || []).length > 1

  // To meet the styling requirements (for the selectedCriteriaPane) containing a menu item that consist of a dropdown selection menu instead of a plain link,
  // the SelectPicket component is hidden underneath the ExploreButton component.
  // When clicking on the ExploreButton component, the dropdown menu of the SelectPicker component is opened and shown underneath,
  // allowing us to use all features of a SelectPicker component and still have the selected value displayed as requested.

  return (
    <div ref={ref} className={styles.container}>
      <div className={styles.overlay}>
        <ExploreButton size="sm" appearance="link" onClick={handleOpenDropdown}>
          {props.label}
        </ExploreButton>
        <div
          className="mb-10 language"
          onClick={handleOpenDropdown}
          style={{ cursor: 'pointer' }}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleOpenDropdown()
            }
          }}
        >
          {props.data?.find(({ value }) => value === props.value)?.label || props.value}
          {showDropDown &&
            (isSelectOpen ? (
              <BsChevronUp className="ml-10" size={14} />
            ) : (
              <BsChevronDown className="ml-10" size={14} />
            ))}
        </div>
      </div>
      {showDropDown && (
        <div className={styles.selectWrapper}>
          <Select
            {...props}
            ref={selectRef}
            onOpen={() => setIsSelectOpen(true)}
            onClose={() => setIsSelectOpen(false)}
          />
        </div>
      )}
    </div>
  )
})

ExploreDropDown.displayName = 'ExploreDropDown'

export default ExploreDropDown
